import 'bootstrap/js/dist/tab';
import 'bootstrap/js/dist/dropdown';

import { Controller } from "stimulus"
import EnrollmentContractService from "../entrypoints/src/admin/services/enrollment-contract-service";
import AjaxLoader from '../entrypoints/src/admin/utilities/ajax-loader';
import sweet_alert from '../entrypoints/src/admin/utilities/sweet_alert';

export default class extends Controller {
  static targets = [
    'cancelModal',
    'finishModal',
    'reasonCancellationSelect',
    'attendancesStrategySelect',
    'tuitionsStrategySelect',
    'canceledReason',
    'tuitionsSelections',
    'tuitionsCheckbox',
    'buttonAttachContract',
    'attachContractForm',
    'finishAttendancesEndDate',
    'cancelAttendancesEndDate',
    'attendancesEndDateHint',
    'finishStudentAccess',
    'cancelStudentAccess'
  ];

  connect() {
    $(this.element).on('click', '.enrollment-contract-nav a.nav-link', (ev) => {
      let nav, $a = ev.currentTarget;
      ({ nav } = $a.getAttribute('href').match(/\?nav=(?<nav>.*)$/).groups);

      if (!nav)
        return;

      let url = new URL(window.location);
      url.searchParams.set('nav', nav);
      url.search = url.searchParams;
      history.pushState({}, null, url.toString());
    });

    this.hasButtonAttachContractTarget && this.buttonAttachContractTarget.addEventListener('click', (ev) => this.attachContract(ev));
  }

  attachContract(ev) {
    ev.preventDefault();
    AjaxLoader.show();
    this.attachContractFormTarget.submit();
  }

  removeDiscount(ev) {
    ev.preventDefault();

    sweet_alert.fire({
      title: 'Deseja realmente remover o desconto?',
      icon: 'warning',
      html: 'Todos os contratos ativos e mensalidades abertas, serão atualizadas e perderão o desconto aplicado.',
      focusConfirm: false,
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonText: 'Sim, quero remover o desconto!',
      cancelButtonText: 'Não, cancelar!',
      width: 600
    }).then((resp) => {
      if (!resp.isConfirmed)
        return;

      let htmlForm = `
        <form action="${ev.target.getAttribute('href')}" method="post" class="enrollment-remove-discount">
          <input type="hidden" name="_method" value="delete" />
          <button class="hidden remove-discount"></button>
        </form>
      `;
      document.querySelector('body').insertAdjacentHTML('afterbegin', htmlForm);
      document.querySelector('form.enrollment-remove-discount button.remove-discount').click();
    });
  }

  selectAll(ev) {
    let checkbox = ev.target;
    this.tuitionsCheckboxTargets.forEach((ck) => ck.checked = checkbox.checked);
  }

  async askUpdateContract(ev) {
    let target = ev.currentTarget;
    this.enrollmentContractId = target.dataset.contractId;

    try {
      let response = await EnrollmentContractService.debits(this.enrollmentContractId);
      this.tuitionsSelectionsTargets.forEach(($target) => $target.innerHTML = response);
      $(this[`${target.dataset.contractAction}ModalTarget`]).modal('show');
    } catch (ex) {
      console.log(ex)
      sweet_alert.fire('Opa', 'Não conseguimos carregar os débitos desse contrato.', 'error');
    }
  }

  async cancelContract() {
    try {
      let response = await EnrollmentContractService.cancel(
        this.enrollmentContractId,
        this.reasonCancellationSelectTarget.value,
        this.canceledReasonTarget.value,
        this.selectedTuitionIds,
        this.cancelAttendancesEndDateTarget.value,
        this.strategyOf(this.cancelStudentAccessTarget)
      );

      if (!response.error) {
        return sweet_alert.fire('Feito', 'Contrato cancelado com sucesso', 'success').then(() => {
          window.location.reload();
        })
      }

      sweet_alert.fire('Opa', 'Não foi possível cancelar esse contrato.', 'error')
    } catch (ex) {
      sweet_alert.fire('Opa', 'Não foi possível cancelar esse contrato.', 'error')
    }
  }

  async finishContract() {
    try {
      let response = await EnrollmentContractService.finish(
        this.enrollmentContractId, {
          attendances_strategy: this.attendancesStrategySelectTarget.value,
          tuitions_strategy: this.tuitionsStrategySelectTarget.value,
          attendances_end_date: this.finishAttendancesEndDateTarget.value,
          student_access_strategy: this.strategyOf(this.finishStudentAccessTarget),
          tuition_finish_ids: this.selectedTuitionIds
        }
      );

      if (!response.error) {
        return sweet_alert.fire('Feito', 'Contrato finalizado com sucesso', 'success').then(() => {
          window.location.reload();
        })
      }

      sweet_alert.fire('Opa', 'Não foi possível finalizar esse contrato.', 'error')
    } catch (ex) {
      sweet_alert.fire('Opa', 'Não foi possível finalizar esse contrato.', 'error')
    }
  }

  // Deleting the pending classes and "show the student until date X" would contradict each other, so
  // choosing to delete locks the date on today and says why.
  syncAttendancesEndDate() {
    let deleting = this.attendancesStrategySelectTarget.value === 'destroy';
    let field = this.finishAttendancesEndDateTarget;

    field.disabled = deleting;
    if (deleting && field._flatpickr)
      field._flatpickr.setDate(new Date(), true);

    this.attendancesEndDateHintTarget.textContent = deleting
      ? this.attendancesEndDateHintTarget.dataset.lockedHint
      : this.attendancesEndDateHintTarget.dataset.defaultHint;
  }

  // A disabled select submits nothing; keep the server on the safe side by saying so explicitly.
  strategyOf(select) {
    return select.disabled ? 'void' : select.value;
  }

  get selectedTuitionIds() {
    return [...this.tuitionsCheckboxTargets].filter((ck) => ck.checked).map((ck) => ck.value);
  }
}